import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src"];
import { watchEffect, ref, nextTick } from "../../../../adapter-vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-face',
  props: {
    content: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    isPC: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var data = ref();
    var skeleton = ref();
    watchEffect(function () {
      data.value = props.content;
      if (!data.value) return;
      nextTick(function () {
        // todo 大小显示
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "message-image",
        ref_key: "skeleton",
        ref: skeleton
      }, [_createElementVNode("img", {
        "class": "message-image",
        src: _unref(data).url
      }, null, 8, _hoisted_1)], 512);
    };
  }
});